import { z } from 'zod';
import { exhibitorCoreSchema, exhibitorStatusSchema } from '../core';

// 2025 年度の電源容量 dropdown 区分。
export const powerCapacity2025Schema = z.enum(['under100VA', 'under200VA', 'over200VA']);
export type PowerCapacity2025 = z.infer<typeof powerCapacity2025Schema>;

// 2025 年度のブースサイズ希望 (0.5 ブース運用は 2025 のみ)。
export const boothSizePreference2025Schema = z.enum([
  'full-only',    // 0.5 にしてほしくない (1 ブース希望)
  'prefer-full',  // 0.5 でもよいが、できれば 1 ブース
  'half-ok',      // 0.5 ブースでよい
  'half-prefer',  // 0.5 ブースを積極的に希望
]);
export type BoothSizePreference2025 = z.infer<typeof boothSizePreference2025Schema>;

// 2025 年度の申込スキーマ。机椅子セット概念 + 電源容量 dropdown + 0.5 ブース希望。
// 2025 イベント終了後、新規 INSERT は発生しない (admin の legacy view からの read/edit のみ)。
export const exhibitorApplication2025Schema = exhibitorCoreSchema.extend({
  needsTable: z.boolean(),
  needsChair: z.boolean(),
  additionalTables: z.number().min(0).max(5),
  additionalChairs: z.number().min(0).max(10),
  needsPower: z.boolean(),
  powerCapacity: powerCapacity2025Schema.optional(),
  customPowerCapacity: z.number().min(200).optional(),
  boothSizePreference: boothSizePreference2025Schema,
  isHalfBooth: z.boolean().optional(),
});

export const exhibitorAdminFullUpdate2025Schema = exhibitorApplication2025Schema
  .omit({ agreedToTerms: true, agreedToSafetyGuidelines: true })
  .extend({ status: exhibitorStatusSchema.optional() });

export type ExhibitorApplication2025Input = z.infer<typeof exhibitorApplication2025Schema>;
export type ExhibitorAdminFullUpdate2025Input = z.infer<typeof exhibitorAdminFullUpdate2025Schema>;
